// The name of the place you're standing in: the HUD's place plate and the knock-out card both read it from here, so
// they never disagree (review R2-017: the card said "a shop 51 metres north" while the plate said 2 AM SLICE).
interface PlaceB { id: number; venue?: string; sign?: string; bbox: number[] }

/** a venue's own name, else the shop's sign; a unit with no sign of its own is named by the signed shop it shares a wall
 *  with ("NEXT TO 2 AM SLICE"), on the same side of the street; '' when there's nothing to go on */
export function placeName(B: PlaceB, all: (PlaceB | null)[], venues: Record<string, { name?: string }>): string {
  const own = (b: PlaceB) => (b.venue && venues[b.venue]?.name) || b.sign || '';
  if (own(B)) return own(B);
  let best = '', bd = 3;                          // cells: touching, or a wall's width apart
  for (const o of all) {
    if (!o || o.id === B.id || !own(o) || o.bbox[1] >= B.bbox[3] || o.bbox[3] <= B.bbox[1]) continue;
    const gap = Math.max(0, o.bbox[0] - B.bbox[2], B.bbox[0] - o.bbox[2]);
    if (gap < bd) { bd = gap; best = own(o); }
  }
  return best ? `NEXT TO ${best}` : '';
}

interface PlaceMap { g: ArrayLike<number>; w: number; h: number }
const bands = new WeakMap<object, [number, number]>();
/** the rows of Whyte Ave itself: the row with the most yellow centre line (ground 2), give or take 17 m (roadway and both
 *  sidewalks). The alley ground layer is painted across the Ave in places (review R4-022: THE ALLEY over the centre
 *  line), so inside this band it's always the Ave. */
function aveBand(m: PlaceMap): [number, number] {
  let b = bands.get(m); if (b) return b;
  let best = 0, bn = -1;
  for (let y = 0; y < m.h; y++) { let n = 0; for (let x = 0; x < m.w; x++) if (m.g[x + y * m.w] === 2) n++; if (n > bn) { bn = n; best = y; } }
  bands.set(m, b = [best - 34, best + 34]); return b;
}
/** outdoors: THE ALLEY on alley or back-lot ground (7, 8) off the Ave, else WHYTE AVE; cells */
export function outdoorName(m: PlaceMap, cx: number, cy: number): 'THE ALLEY' | 'WHYTE AVE' {
  if (cx < 0 || cy < 0 || cx >= m.w || cy >= m.h) return 'WHYTE AVE';
  const g = m.g[cx + cy * m.w], [y0, y1] = aveBand(m);
  return (g === 7 || g === 8) && (cy < y0 || cy > y1) ? 'THE ALLEY' : 'WHYTE AVE';
}
